import { env } from "@/config/env";
import { churchApi, unwrap } from "./client";
import { normalizePropheticDeclaration, PROPHETIC_FALLBACK } from "./normalize";
import type { PropheticDeclaration } from "@/types";

/**
 * GET /api/prophetic-declaration — a new contract for the website on the church API.
 * Expected shape (any of these fields may be missing):
 *   { data: { title, speaker, audioUrl, description, date } }
 *
 * This never throws: a failed request, an empty response or a missing audio URL all resolve to
 * the placeholder declaration so the homepage keeps its shape.
 */
export async function getPropheticDeclaration(signal?: AbortSignal): Promise<PropheticDeclaration> {
  try {
    const body = await churchApi<unknown>("/api/prophetic-declaration", { signal, timeoutMs: 20_000 });
    const declaration = normalizePropheticDeclaration(unwrap(body));
    if (declaration?.audioUrl) return declaration;
    if (declaration) return { ...declaration, audioUrl: env.propheticFallbackAudio || null };
  } catch (err) {
    if (signal?.aborted) throw err;
  }
  return env.propheticFallbackAudio
    ? { ...PROPHETIC_FALLBACK, audioUrl: env.propheticFallbackAudio, description: null }
    : PROPHETIC_FALLBACK;
}
